import React from 'react';
import { Redirect } from 'react-router';
import { ChatScreen } from '../../screens/general/chat/ChatScreen';
import { CertificateDownloadScreen } from '../../screens/general/certificate-download/CertificateDownloadScreen';
import { ImpactDashboardScreen } from '../../screens/general/impact-dashboard/ImpactDashboardScreen';
import { SupportScreen } from '../../screens/general/support/SupportScreen';
import { VolDashboardMyElementsScreenRouter } from '../../screens/general/vol-dashboard/vol-dashboard-my-elements/VolDashboardMyElementsScreenRouter';
import { CampfireSwitch } from '../common/CampfireSwitch';
import MiniRoute from '../common/MiniRoute';
import { useRoutesMap } from '../common/useRoutesMaps';
import { useIsPageHidden } from '../../global/auth/use-hidden-pages/use-hidden-pages';

const getLegacyRoutes = ({ route, isAuthorized }: { route: string; isAuthorized: boolean }): Array<React.ReactNode> => [
  <MiniRoute
    //
    key={`/${route}/support-and-resources`}
    path={`/${route}/support-and-resources`}
    component={() => <Redirect to={`/${route}/resources`} />}
    isAuthorized={isAuthorized}
  />,
];

export const FixedContentBlock = () => {
  const {
    fixed: { route, isAuthorized },
  } = useRoutesMap();
  const isPageHidden = useIsPageHidden();

  return (
    <CampfireSwitch>
      {getLegacyRoutes({ route, isAuthorized })}
      <MiniRoute
        //
        path={`/${route}/my-elements`}
        component={VolDashboardMyElementsScreenRouter}
        isAuthorized={isAuthorized}
      />
      <MiniRoute
        //
        path={`/${route}/certificates/:certificateId`}
        component={CertificateDownloadScreen}
        isAuthorized={isAuthorized}
      />
      {!isPageHidden('dashboard.resources') && (
        <MiniRoute
          //
          path={`/${route}/resources`}
          component={SupportScreen}
          isAuthorized={isAuthorized}
        />
      )}
      {!isPageHidden('dashboard.impact-dashboard') && (
        <MiniRoute
          //
          path={`/${route}/impact-dashboard`}
          component={ImpactDashboardScreen}
          isAuthorized={isAuthorized}
        />
      )}
      {!isPageHidden('dashboard.chat') && (
        <MiniRoute
          //
          path={`/${route}/chat`}
          component={ChatScreen}
          isAuthorized={isAuthorized}
        />
      )}
    </CampfireSwitch>
  );
};

export default FixedContentBlock;
